class UserTypeEnum {
  static ADMIN = 'administrator';
  static APPLICANT = 'applicant';
  static EMPLOYEE = 'employee';
  static TENANT_MEMBER = 'tenant_member';
}

export default UserTypeEnum;
